import React from "react";
import { Modal, Upload, Button, Spin } from "antd";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import styled from "styled-components";
import { listCustomEmailFiles, uploadCustomEmailFile } from "../../../Services/customEmail";
import { CePage } from "../styles";

const Files = styled.div`
  .flist { max-height: 300px; overflow: auto; }
  .file { display: grid; grid-template-columns: 40px minmax(0, 1fr) auto; gap: 10px; align-items: center; padding: 8px; border: 1px solid var(--border); border-radius: 8px; margin-bottom: 8px; }
  .ficon { width: 40px; height: 40px; border-radius: 6px; background: var(--primary-soft); color: var(--primary-text); display: grid; place-items: center; font-size: 11px; font-weight: 700; }
  .ant-upload-wrapper .ant-upload-drag { border-color: var(--border); background: var(--surface); }
`;

const kb = (n) => (n >= 1024 * 1024 ? `${(n / 1024 / 1024).toFixed(1)} MB` : `${Math.max(1, Math.round(n / 1024))} KB`);
const IMAGES = "image/jpeg,image/png,image/gif,image/webp";

// Upload once, reuse in any campaign (custom_email_files).
const FileLibraryModal = ({ open, onClose, onPick, accept = "any" }) => {
  const queryClient = useQueryClient();
  const { data: files = [], isLoading } = useQuery({
    queryKey: ["custom_email_files"],
    queryFn: listCustomEmailFiles,
    enabled: open,
    refetchOnWindowFocus: false,
  });
  const shown = accept === "image" ? files.filter((f) => f.mime_type.startsWith("image/")) : files;

  const customRequest = async ({ file, onSuccess, onError }) => {
    try {
      const saved = await uploadCustomEmailFile(file);
      await queryClient.invalidateQueries({ queryKey: ["custom_email_files"] });
      onSuccess(saved);
      onPick(saved);
    } catch (e) {
      onError(e);
    }
  };

  return (
    <Modal open={open} onCancel={onClose} footer={null} title={accept === "image" ? "Insert an image" : "Upload or choose a file"} width={560} destroyOnClose>
      <CePage>
        <Files>
          <Upload.Dragger accept={accept === "image" ? IMAGES : `${IMAGES},application/pdf`} customRequest={customRequest} showUploadList={false} multiple={false}>
            <div className="muted">Drop a file here or <u>browse</u></div>
            <div className="note">JPG, PNG, GIF, WEBP{accept === "image" ? "" : " or PDF"}, up to 10 MB. Saved once and reusable in any campaign.</div>
          </Upload.Dragger>
          <div className="note" style={{ margin: "14px 0 8px", fontWeight: 600 }}>Previously uploaded</div>
          <div className="flist">
            {isLoading ? <Spin /> : !shown.length ? <div className="note">No files yet.</div> : shown.map((f) => (
              <div className="file" key={f.id}>
                <div className="ficon">{f.mime_type === "application/pdf" ? "PDF" : "IMG"}</div>
                <div><div style={{ overflowWrap: "anywhere" }}>{f.original_name}</div><div className="note">{kb(f.file_size)}</div></div>
                <Button size="small" type="primary" onClick={() => onPick(f)}>Use</Button>
              </div>
            ))}
          </div>
        </Files>
      </CePage>
    </Modal>
  );
};

export default FileLibraryModal;
